import React from "react";

import { cn, PageHeader, Paragraph } from "@skydio/rivet-ui";

import type { TagType } from "antd";

export interface SettingsPageViewProps {
  title: string | React.ReactNode;
  subTitle?: string | React.ReactNode;
  link?: {
    text: string;
    url: string;
  };
  tags?: React.ReactElement<TagType> | React.ReactElement<TagType>[];
  extra?: React.ReactNode;
  breadcrumbs?: React.ReactNode;
  children?: React.ReactNode;
  withDivider?: boolean;
  contentClassName?: string;
}

/**
 * A page view for making all our settings pages consistent
 * If you are making a page not in the settings, you can use just the classic PageHeader
 * rivet component, and add subtitles and tags and buttons as needed
 */
const SettingsPageView: React.FC<SettingsPageViewProps> = ({
  title,
  subTitle,
  link,
  tags,
  extra,
  withDivider = true,
  breadcrumbs,
  children,
  contentClassName,
}) => {
  return (
    <>
      <PageHeader withDivider={withDivider}>
        {breadcrumbs && breadcrumbs}
        <PageHeader.Heading>
          <PageHeader.Heading.Main>
            <PageHeader.Heading.Title>{title}</PageHeader.Heading.Title>
            {tags}
          </PageHeader.Heading.Main>
          {extra && <PageHeader.Heading.Extra>{extra}</PageHeader.Heading.Extra>}
        </PageHeader.Heading>
        {/* NOTE(jesse): This intentionally doesn't use the PageHeader.subtitle as that
        places the description inline with the title and we want to place the description
         underneath */}
        <PageHeader.Content>
          <Paragraph emphasis="secondary">
            {subTitle && <span>{subTitle} </span>}
            {link && (
              <a href={link.url} target="_blank" rel="noopener noreferrer" className="text-sm">
                {link.text}
              </a>
            )}
          </Paragraph>
        </PageHeader.Content>
      </PageHeader>
      <div className={cn("flex flex-col gap-6 px-8 pb-8", withDivider && "pt-4", contentClassName)}>
        {children}
      </div>
    </>
  );
};

export default SettingsPageView;
